module.exports = __webpack_public_path__ + "img/404-not-found.e84b5c94.png";